import { ORDER_STAGE_BY_NUMBER, stageDisplayLabelKey, stageKey } from '@/entities/order';
import { PRIORITY_STAGE_IDS } from '../model/use-status-priority';

export interface PriorityStageItem {
  number: number;
  /**
   * `orders:` i18n key of the row label — the timer-group phrase for the
   * active delivery range (cpanel `getStageDisplayLabel(n) || name`), else
   * the stage name (`stage.<slug>`).
   */
  i18nKey: string;
  /** Russian fallback label. */
  name: string;
  color: string;
}

/**
 * Build the ordered list of priority-stage rows for the dialog. Ported verbatim
 * from cpanel `buildStageList`: render EXACTLY the PRIORITY_STAGE_IDS set —
 * append any missing ids after the saved order, drop any saved id not in the
 * priority set (silently prunes invalid, auto-adds new priority stages).
 */
export function buildStageList(order: number[]): PriorityStageItem[] {
  const seen = new Set<number>();
  const result: PriorityStageItem[] = [];
  const priorityIds = PRIORITY_STAGE_IDS as readonly number[];

  const append = (n: number) => {
    if (seen.has(n) || !priorityIds.includes(n)) return;
    const meta = ORDER_STAGE_BY_NUMBER.get(n);
    if (!meta) return;
    seen.add(n);
    result.push({
      number: meta.number,
      i18nKey: stageDisplayLabelKey(meta.number) ?? `stage.${stageKey(meta.number)}`,
      name: meta.name,
      color: meta.color,
    });
  };

  order.forEach(append);
  priorityIds.forEach(append);
  return result;
}
